import { DialogContent, DialogHeader } from "../../../../components/ui/dialog";
import { useToast } from "../../../../hooks/use-toast";
import Spinner from "../../../../components/spinner.components";
import { useNavigate, useParams } from "react-router-dom";
import { handleHttpError } from "../../../../utils/utils";
import { Button } from "../../../../components/ui/button";
import { DialogClose } from "@radix-ui/react-dialog";
import { useCloneCampaignAdminHttp } from "../../../../hooks/http/admin/campaigns/clone-campaign.admin.http";

export const DuplicateCampaignModalPartial: React.FunctionComponent = () => {
	const { execute: cloneCampaignHttp, fetching: cloningCampaign } =
		useCloneCampaignAdminHttp();
	const { toast } = useToast();

	const { campaignId } = useParams();

    const navigate = useNavigate();

	async function cloneCampaign() {
		if (!campaignId) {
			return;
		}
		const response = await cloneCampaignHttp({
			body: null,
			pathParams: { id: campaignId },
		});
		if (!response.success) {
			return handleHttpError(response, toast);
		}
		toast({
			content: "Campaign Duplicated successfully",
			toastType: "success",
		});

        navigate(`/admin/campaigns/${response.data.campaign.id}/edit`);
        
	}
	return (
		<DialogContent className="flex flex-col items-center gap-16 py-10 border-border w-full max-w-2xl text-center text-primary">
			<DialogHeader className="flex items-center gap-2 w-full">
				<h2 className="font-semibold text-3xl text-center">
					Are you sure you wanna duplicate
					<br />this campaign ?
				</h2>
				<p className="font-semibold text-center text-secondary">
					This action will duplicate this campaign and all its details.
				</p>
			</DialogHeader>
			<div className="flex justify-center items-center gap-5 w-full">
				<DialogClose className="">
					<Button className="bg-tertiarybuttonbg px-20 py-8 border border-border w-56 font-semibold text-[18px]">
						Cancel
					</Button>
				</DialogClose>
				<Button
                    disabled={cloningCampaign}
					onClick={cloneCampaign}
					className="bg-primarybuttonbg px-20 py-8 w-56 font-semibold text-[18px] text-primarybuttontext"
				>
					{cloningCampaign ? <Spinner width={20} /> : "Duplicate"}
				</Button>
			</div>
		</DialogContent>
	);
};
